import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { PropertyService } from '../properties/service/property.service';
import { MessageService } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { usPhoneValidator } from '../../core/shared/validators/us-phone.validator';
import { PhoneUtils } from '../../core/shared/utils/phone.utils';
@Component({
  selector: 'app-create-tenants',
  standalone: true,
  imports: [
    DialogModule,
    CommonModule,
    ReactiveFormsModule,
    DropdownModule,
    InputTextModule,
    ButtonModule,
    TableModule,
    ToastModule,
    NgxMaskDirective 
  ],
  providers:[MessageService, provideNgxMask()],
  templateUrl: './create-tenants.component.html',
  styleUrls: ['./create-tenants.component.scss'],
})


export class CreateTenantsComponent {
  @Input() tenantData: any | null = null;
  @Output() closeDialog = new EventEmitter<void>();
  tenantForm: FormGroup; 
  tenantdata: any;


  constructor
  (
    private fb: FormBuilder,
    private propertyService: PropertyService,
    private messageService: MessageService,
  ) {


    this.tenantForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      //phone: ['+1', [Validators.required, Validators.maxLength(16), Validators.pattern(/^\+1\d{10,15}$/)]], // International format starting with +1
      phone: ['', [Validators.required, usPhoneValidator]], // US format xxx-xxx-xxxx
      user_type: ['tenant', Validators.required],
      // password: ['', Validators.required],
    });
  }

  ngOnInit(): void {
  if (this.tenantData) {
    let phone = this.tenantData.phone || '';
    // Remove +1 if present
    if (phone && phone.startsWith('1')) {
      phone = phone.substring(1); // cut off 1
    } else if (phone.startsWith('+1')) {
      phone = phone.substring(2); // cut off +1
    }
    this.tenantForm.patchValue({
      email: this.tenantData.email,
      first_name: this.tenantData.first_name,
      last_name: this.tenantData.last_name,
      phone: phone,
      password: this.tenantData.password
    });
  }

  }

  onSubmit(): void {
    if (this.tenantForm.valid) {
      const tenantPayload = this.tenantForm.value;
      //Add +1 prefix and remove dashes for US number
      tenantPayload.phone = PhoneUtils.toE164(tenantPayload.phone);
      console.log('Tenant Payload:', tenantPayload);
      if (this.tenantData) {
        this.updateTenant(tenantPayload);
      } else {
        this.createTenant(tenantPayload);
      }
    } else {
      console.error('Form is invalid');
    }
  }

  createTenant(tenantPayload: any): void {
    this.propertyService.createTenant(tenantPayload).subscribe(
      (response) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Tenant created successfully!',
        });
        this.closeDialog.emit();
      },
      (e) => {
        console.error('Error creating tenant:', e.error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: e.error.message ?? 'Failed to create tenant!',
        });
      }
    );
  }

  updateTenant(tenantPayload: any): void {
    if (this.tenantData && this.tenantData._id) {
      this.propertyService.updateTenant(this.tenantData._id, tenantPayload).subscribe(
        (response) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Tenant updated successfully!',
          });
          this.closeDialog.emit();
        },
        (e) => {
          console.error('Error updating tenant:', e);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: e.error.message ?? 'Failed to update tenant!',
          });
        }
      );
    }
  }

  enforcePrefix(event: any) {
    const phoneCtrl = this.tenantForm.get('phone');
    const input: HTMLInputElement = event.target; // actual input element

    if (phoneCtrl) {
      let val: string = phoneCtrl.value || '';

      // Always enforce +1 prefix
      if (!val.startsWith('+1')) {
        val = '+1' + val.replace(/^\+?1?/, '');
      }

      // Remove all non-digits after +1
      //console.log('Before formatting:', val);
      val = '+1' + val.substring(2).replace(/\D/g, '');

      //console.log('After formatting:', val);
      // Update value
      phoneCtrl.setValue(val, { emitEvent: false });

      // Force cursor to end (fixes numpad typing issue too)
      requestAnimationFrame(() => {
        input.selectionStart = input.selectionEnd = val.length;
      });
    }
  }
}
